export default __webpack_public_path__ + "065c0a4c6c6152148f778f12374bb07f.twig";